<script>
	import cn from 'classnames';
	import Heading from '../(components)/Heading.svelte';
	import ScooterLarge from '$lib/images/svg/scooter-large.svelte';
	import PartsLarge from '$lib/images/svg/parts-large.svelte';
	import Button from '../(components)/Button.svelte';

	let lineCls =
		"relative w-full overflow-hidden [&:before]:content-[''] [&:before]:w-32 [&:before]:h-[2px] [&:before]:bg-white [&:before]:absolute [&:before]:top-1/2 [&:before]:z-20 [&:before]:left-1/2 [&:before]:-translate-x-1/2 [&:after]:content-[''] [&:after]:h-[2px] [&:after]:left-1/2 [&:after]:w-[999px] [&:after]:block [&:after]:bg-gray-concrete [&:after]:absolute [&:after]:-translate-x-1/2 [&:after]:top-1/2";
</script>

<div class={cn('flex flex-col gap-y-4 md:grid md:grid-cols-2 md:gap-x-7', $$props.class)}>
	<div
		class="flex flex-col items-center border border-gray-mercury bg-white p-2.5 pt-8 text-center shadow-sm md:px-16 md:pb-14 md:shadow-md"
	>
		<div class={cn(lineCls, 'mb-9')}>
			<ScooterLarge class="relative z-20 mx-auto h-auto w-24" />
		</div>

		<Heading tag="h2" class="mb-4 text-2xl">Náhradní díly na konkrétní skútr</Heading>
		<p class="mb-8 md:mb-12">
			Vyberte typ skútru a my vám zobrazíme náhradní díly, které budou 100% pasovat!
		</p>
		<Button href="/skutry/" class="mt-auto w-full max-w-80 py-3">Vybrat skútr</Button>
	</div>

	<div
		class="flex flex-col items-center border border-gray-mercury bg-white p-2.5 pt-8 text-center shadow-sm md:px-16 md:pb-14 md:shadow-md"
	>
		<div class={cn(lineCls, 'mb-9')}>
			<PartsLarge class="relative z-20 mx-auto h-auto w-24" />
		</div>

		<Heading tag="h2" class="mb-4 text-2xl">Univerzální náhradní díly</Heading>
		<p class="mb-8 md:mb-12">Univerzální náhradní díly, které pasují na každý skútr!</p>
		<Button href="/univerzalni-dily" class="mt-auto w-full max-w-80 py-3">Univerzální díly</Button>
	</div>
</div>
